import { BASE_APPLICATION_HOST, BFF_WEB_HOST, BFF_WEB_PATH, BFF_WEB_PORT } from '@constants/env';

export const getDomain = (hostname = BASE_APPLICATION_HOST): string =>
  hostname.includes('.') ? hostname.replace(/^([^.]*)\./, '') : '';

export const getBffWebHost = (domain = getDomain()): string => BFF_WEB_HOST.replace('{DOMAIN}', domain);

export const getBffWebUrl = (domain = getDomain()): string => {
  if (BFF_WEB_PORT) {
    return `${getBffWebHost(domain)}:${BFF_WEB_PORT}/${BFF_WEB_PATH}`;
  }
  return `${getBffWebHost(domain)}/${BFF_WEB_PATH}`;
};
